import { render, staticRenderFns } from "./CompareViewItem.vue?vue&type=template&id=5dbb8356&scoped=true&"
import script from "./CompareViewItem.vue?vue&type=script&lang=js&"
export * from "./CompareViewItem.vue?vue&type=script&lang=js&"
import style0 from "./CompareViewItem.vue?vue&type=style&index=0&id=5dbb8356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbb8356",
  null
  
)

export default component.exports